'use strict';

import {fabric} from 'fabric-webpack';

export const BaseFilter = fabric.Image.filters.BaseFilter;
export const Brightness = fabric.Image.filters.Brightness;
export const Convolute = fabric.Image.filters.Convolute;
export const GradientTransparency = fabric.Image.filters.GradientTransparency;
export const Grayscale = fabric.Image.filters.Grayscale;
export const Invert = fabric.Image.filters.Invert;
export const Mask = fabric.Image.filters.Mask;
export const Multiply = fabric.Image.filters.Multiply;

export const Noise = fabric.Image.filters.Noise;
export const Pixelate = fabric.Image.filters.Pixelate;
export const RemoveWhite = fabric.Image.filters.RemoveWhite;
export const Resize = fabric.Image.filters.Resize;
export const Sepia = fabric.Image.filters.Sepia;
export const Sepia2 = fabric.Image.filters.Sepia2;
export const Tint = fabric.Image.filters.Tint;



/** WEBPACK FOOTER **
 ** ./src/ImageFilters.js
 **/